<template>
  <div class="wl-certify-site-wrapper">
    <div class="new-center-content clearfix">
      <div class="new-center-top fl clearfix">
        <div class="new-top-nav" :style="{background:'url('+imgs+')'}">
           <div class="menu-sp-text">S</div>
          <div class="fl" style="padding-left:4px;">
            <p class="new-top-navtitle">认证站点</p>
            <p class="new-top-ews">ite</p>
          </div>
        </div>
        <div class="new-center-tab">
          <div class="site-menu-con" v-for="(item,index) in certifySiteMenu" :key="index">
            <div
              class="clearfix site-menu-li"
              :class="{menuActive : menuActiveName == item.name}"
              @click="tabParentMenu(item.name, item.childMenu ? item.childMenu[0].name : '')"
            >
              {{item.name}}
              <i class="wl-icon wl-icon-xiangyou fr" v-if="!item.childMenu"></i>
              <i class="wl-icon-xiangxia fr" v-if="item.childMenu"></i>
            </div>
            <div
              v-for="(citem,index) in item.childMenu"
              :key="index"
              class="clearfix site-menu-li site-menu-child-li"
              :class="{menuActive : cildActiveName == citem.name}"
              @click="tabChildMenu(item.name, citem.id, citem.name)"
            >
              <i class="wl-icon-dian"></i>
              {{citem.name}}
            </div>
          </div>
        </div>
      </div>

      <div class="certify-site-show-content fr">
        <div class="new-center-list clearfix">
          <h2 class="certify-content-title">{{certifySiteName}}</h2>
          <div class="new-center-path">
            <div class="crumbs-text">
              <i class="wl-icon-zhuye1"></i>
              <span>当前位置：</span>
              <span @click="goHome" style="cursor: pointer;">网站首页</span>
              <span>></span>
              <span @click="goActiveDetail">{{certifySiteName}}</span>
              <span v-show="!isShowDetail">
                <span>></span>
                <span>{{activeTitle}}</span>
              </span>
            </div>
          </div>
        </div>
        <div class="site-content-detail">
          <div
            class="site-content-lsit-con"
            v-if="menuActiveName == '申请标准' || menuActiveName == '申请成为站点'"
          >
            <div v-if="menuActiveName == '申请标准'">
              <div v-for="(item,index) in certifySiteData" :key="index" class="site-list-li">
                <h4 class="site-li-h4">
                  <span class="sp-site-title">{{item.title}}</span>
                </h4>
                <div v-html="item.content" class="site-content-html"></div>
              </div>
            </div>
            <div v-if="menuActiveName == '申请成为站点' && pActiveIndex == 1">
              <h4 class="site-li-h4">
                <span class="sp-site-title">申请认证中心的流程</span>
              </h4>
              <div class="site-content-html">
                <img
                  src="https://file.clpp.org.cn/66ykt/ori/quioalgoh5bdatisgfv7sq/WYCZAKf7A8eXpzxw.png"
                >
              </div>
              <h4 class="site-li-h4">
                <span class="sp-site-title">查看认证中心合作协议</span>
              </h4>
              <div class="site-content-html">
                <p class="p-apply-list-li">
                  <i class="wl-icon-dian"></i>
                  <span>申请报告（包括申请项目类别、级别、地域，年最低保证培训人数）及申请表（加盖公章）；</span>
                </p>
                <p class="p-apply-list-li">
                  <i class="wl-icon-dian"></i>
                  <span>营业执照或法人执照、组织机构代码证书、税务登记证（复印件加盖公章）；</span>
                </p>
                <p class="p-apply-list-li">
                  <i class="wl-icon-dian"></i>
                  <span>单位管理制度及培训场地证明文件；</span>
                </p>
                <div class="p-apply-list-li clearfix">
                  <i class="wl-icon-dian fl"></i>
                  <span class="fl">项目分析报告:</span>
                  <div class="fr project-ana-pre">
                    <p class="p-child-ana-pre">（1）单位介绍。要求越详细越好，至少包括单位背景、成立时间、单位规模、部门设置、主要业务等。</p>
                    <p class="p-child-ana-pre">（2）曾经或正在开展的培训教育项目及进展情况、运作模式、合作单位，主要客户；</p>
                    <p class="p-child-ana-pre">
                      （3）所申请项目的营销方案，包括所申请项目在当地市场情况分析、开展该项目的SWOT分析、招
                      生渠道、项目推广策略与计划等。
                    </p>
                  </div>
                </div>
              </div>
              <h4 class="site-li-h4">
                <span class="sp-site-title">认证中心申请表附件下载</span>
              </h4>
               <div class="site-content-html">
                 <img src="https://file.clpp.org.cn/66ykt/ori/ee8gafmo-zjlo6yxz9qmta/EXXQNhkw2BizEP3J.png"/>
               </div>
            </div>
            <div v-if="menuActiveName == '申请成为站点' && pActiveIndex == 1" class="apply-to-site-btn">
              <el-button size="small" type="primary" @click="applyBecomeSite">申请成为站点 ></el-button>
            </div>
            <div v-if="menuActiveName == '申请成为站点' && pActiveIndex == 2" class="upload-apply-document clearfix">
              <div class="apply-form-content clearfix">
                <el-form :model="ruleForm" :rules="rules" ref="ruleForm" :hide-required-asterisk='true' label-width="140px" class="demo-ruleForm">
                  <el-form-item label="站点名称：" prop="site">
                    <el-input v-model="ruleForm.site"></el-input>
                  </el-form-item>
                  <el-form-item label="所属省市：" required>
                    <div class="select-width-form">
                      <el-select v-model="addProvinceName" placeholder="请选择省" @change="getCityList">
                        <el-option
                          v-for="item in proList"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        ></el-option>
                      </el-select>
                    </div>
                    <div class="select-width-form">
                      <el-select v-model="addCityName" placeholder="请选择市">
                        <el-option
                          v-for="item in cityList"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        ></el-option>
                      </el-select>
                    </div>
                  </el-form-item>
                  <el-form-item label="申请为培训站点：">
                    <el-radio v-model="isTrain" label="1">申请</el-radio>
                    <el-radio v-model="isTrain" label="0">不申请</el-radio>
                  </el-form-item>
                  <el-form-item label="申请为考试站点：">
                    <el-radio v-model="isExam" label="1">申请</el-radio>
                    <el-radio v-model="isExam" label="0">不申请</el-radio>
                  </el-form-item>
                  <el-form-item label="管理员账号：" prop="manager">
                    <el-input v-model="ruleForm.manager"></el-input>
                  </el-form-item>
                  <el-form-item label="管理员姓名：" prop="name">
                    <el-input v-model="ruleForm.name"></el-input>
                  </el-form-item>
                  <el-form-item label="手机号：" prop="phone">
                    <el-input v-model="ruleForm.phone" @blur="verificationMobile"></el-input>
                  </el-form-item>
                  <el-form-item label="验证码：" prop="captcha">
                    <!-- <el-input v-model="ruleForm.captcha"></el-input> -->
                     <div class="captcha-phone-input">
                        <el-input v-model="ruleForm.captcha"></el-input>
                    </div>
                    <el-button v-if="show1" type="primary" class="captcha-phone-button" @click="sendMessage()">发送验证码</el-button>
                    <el-button v-if="show2" type="primary" :disabled="true" class="captcha-phone-button">{{count}}s</el-button>
                    <el-button v-if="show3" type="primary" class="captcha-phone-button" @click="sendMessage()">重新获取验证码</el-button>
                  </el-form-item>
                </el-form>
              </div>
              <div class="clearfix">
                <p class="p-upload-apply-doc">上传申请文档：</p>
                <applyFileUpload :url="urlAliyunOSS" :files="files" @done="onAllFilesUpload" class="apply-file-upload"></applyFileUpload>
                <div class="file-class-text clearfix">
                  <p class="p-text-document">中国物流与采购联合会教育站点申请表.doc</p>
                  <a href="https://file.clpp.org.cn/66ykt/ori/62aoalgo67ralzns3hnyea/y8FdfX3Xa5XJBmk6.xls" class="a-download-text">点击下载</a>
                </div>
              </div>
              <div class="sure-upload-btn">
                <el-button class="form-submit-button" type="primary" @click="applySite(isExitPhone)">确定提交</el-button>
              </div>
            </div>
          </div>
          <div v-if="menuActiveName == '认证活动'">
            <div v-if="isShowDetail">
              <ul  class="cerfity-activity-ul">
                <li class="cerfity-activity-li" v-for="(item,index) in siteActivity" :key="index"
                  @click="toSiteActivityDetail(item.id,item.title)">
                  <div class="cerfity-activity-li-con">
                    <h4 class="cerfity-activity-h4">
                      <i class="wl-icon-zhedie"></i> {{item.title}}
                    </h4>
                    <p class="p-site-activity-con">{{item.contentText}}</p>
                    <p class="clearfix p-site-sctivity-info">
                      <span class="fl">来源：{{item.siteName}}</span>
                      <span class="fr">{{item.pulishTime}}</span>
                    </p>
                  </div>
                </li>
              </ul>
              <div class="site-page-con">
                <el-pagination
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                  :current-page="pageIndex"
                  :page-sizes="[10, 20, 30, 40]"
                  :page-size="pageSize"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="total"
                ></el-pagination>
              </div>
            </div>
            <activeDetail v-if="!isShowDetail" :activeId="activeId"></activeDetail>
          </div>

          <div class="query-site-main" v-if="menuActiveName == '站点查询'">
            <div>
              <echarts :options="mapEchartsData"
                style="width:623px;height:512px;margin:0 auto;"
                @click="getProvinceSiteDetail"
              ></echarts>
            </div>
            <ul class="clearfix site-school-list-ul">
              <li
                v-for="(item,index) in schoolList"
                :key="index"
                class="site-school-list-li fl"
                @click="getSiteDetailInfo(item.Id)"
              >{{item.SiteName}}</li>
            </ul>
            <div style="text-align: center; margin: 20px 0">
               <el-pagination
                @size-change="handleSizeChangeSite"
                @current-change="handleCurrentChangeSite"
                :current-page="sitePageIndex"
                :page-sizes="[12, 18, 24, 36]"
                :page-size="sitePageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="siteTotalCount">
                </el-pagination>
            </div>
          </div>
          <div class="query-site-detail-con" v-if="menuActiveName == '站点详细信息'">
            <p class="p-site-detail-title">培训站点查询相关信息显示</p>
            <ul class="site-detail-list-ul">
              <li class="clearfix site-detail-list-li">
                <span class="site-detail-label fl">所在省：</span>
                <span class="fl">{{siteDetailInfo.province}}</span>
              </li>
              <!-- <li class="clearfix site-detail-list-li">
                <span class="site-detail-label fl">类别：</span>
                <span class="fl">{{siteDetailInfo.type}}</span>
              </li> -->
              <li class="clearfix site-detail-list-li">
                <span class="site-detail-label fl">单位名称：</span>
                <span class="fl">{{siteDetailInfo.siteTitle}}</span>
              </li>
              <li class="clearfix site-detail-list-li">
                <span class="site-detail-label fl">联系人：</span>
                <span class="fl">{{siteDetailInfo.displayName}}</span>
              </li>
              <li class="clearfix site-detail-list-li">
                <span class="site-detail-label fl">联系方式：</span>
                <span class="fl">{{siteDetailInfo.mobile}}</span>
              </li>
              <li class="clearfix site-detail-list-li">
                <span class="site-detail-label fl">地址：</span>
                <span class="fl">{{siteDetailInfo.address}}</span>
              </li>
              <li class="clearfix site-detail-list-li">
                <span class="site-detail-label fl">邮箱：</span>
                <span class="fl">{{siteDetailInfo.eMail}}</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import applyFileUpload from "components/applyFileUpload.vue";
import activeDetail from "page/component/school/activeDetail.vue";
import CryptoJS from "crypto-js";
export default {
  data() {
    return {
      ruleForm: {
        site: "",
        manager: "",
        name: "",
        phone: "",
        captcha: ""
      },
      rules: {
        site: [{ required: true, message: "请输入站点", trigger: "blur" }],
        manager: [
          { required: true, message: "请输入管理员账号", trigger: "blur" }
        ],
        name: [
          { required: true, message: "请输入管理员姓名", trigger: "blur" }
        ],
        phone: [{ required: true, message: "请输入手机号", trigger: "blur" }],
        captcha: [{ required: true, message: "请输入验证码", trigger: "blur" }]
      },
      show1: true,
      show2: false,
      show3: false,
      count: 0,
      isTab: 1,
      isShowDetail: true,
      activeTitle: "",
      activeId: "",
      pageIndex: 1,
      pageSize: 10,
      total: 0,
      imgs: require("assets/images/certity-site-bg.png"),
      menuActiveName: "申请标准",
      cildActiveName: "考试站点申请标准",
      certifySiteName: "考试站点申请标准",
      certifySiteMenu: [
        {
          name: "申请标准",
          childMenu: []
        },
        {
          name: "认证活动"
        },
        {
          name: "申请成为站点"
        },
        {
          name: "站点查询",
          childMenu: [
            { id: 1, name: "培训站点查询" },
            { id: 2, name: "考试站点查询" }
          ]
        }
      ],
      value1: "安徽",
      siteActivity: [],
      value: "北京",
      certifySiteData: [],
      certifyStandardData: [],
      applyToSite: [],
      fileIds: [],
      files: "",
      urlAliyunOSS: "/api/design/osssign/getsign",
      mapData: [],
      mapEchartsData: {},
      schoolList: [],
      siteDetailInfo: {
        province: "",
        type: "",
        company: "",
        linkPerson: "",
        linkWay: "",
        address: "",
        email: ""
      },
      pActiveIndex: 1,
      siteType: 1,
      siteTotalCount: 0,
      sitePageSize: 12,
      sitePageIndex: 1,
      provinceName: "",
      isExitPhone: false,
      proList: [],
      cityList: [],
      addProvinceName: "",
      addCityName: "",
      isTrain: "1",
      isExam: "1",

    };
  },
  created() {
    this.certifySiteData = this.certifyStandardData;
    this.getSiteCertifyList();
    this.getAllProvinceList();
  },
  components: {
    applyFileUpload,
    activeDetail
  },
  computed: {
    association: function() {
      return this.$store.state.association;
    }
  },
  methods: {
    //获取省市
    getAllProvinceList() {
      this.$http
        .post("/api/XOrg/AssociationSites/getAllProvinceList", {})
        .then(rst => {
          if (rst.code > 0) {
            this.proList = rst.province;
          }
        });
    },
    getCityList() {
      debugger;
      var that = this;
      that.addCityName = "";
      this.$http
        .post("/api/XOrg/AssociationSites/getCityList", {
          province: that.addProvinceName
        })
        .then(rst => {
          if (rst.code > 0) {
            that.cityList = rst.cityList;
          }
        });
    },
    //验证码
    sendMessage() {
      var once = true;
      let str_ = Date.parse(new Date()) / 1000;
      let str = this.encryption(str_);
      let str1 = CryptoJS.MD5(str_ + "").toString();
      var s1 = str1.substring(0, 7);
      var s2 = str1.substring(7);
      console.log(this.ruleForm.phone);
      str1 = s1 + "s" + s2;
      if (once) {
        var that = this;

        this.$http
          .post("/api/XOrg/XLogin/sendCode", {
            verifyInfo: that.ruleForm.phone,
            str: str,
            str1: str1
          })
          .then(rst => {
            if (rst.code > 0) {
              this.$message.success(rst.msg);
              this.verifyCode = rst.verifyCode;
              const TIME_COUNT = 60;
              if (!this.timer) {
                this.count = TIME_COUNT;
                this.show1 = false;
                this.show2 = true;
                this.show3 = false;
                this.timer = setInterval(() => {
                  if (this.count > 0 && this.count <= TIME_COUNT) {
                    this.count--;
                    once = false;
                  } else {
                    this.show1 = false;
                    this.show2 = false;
                    this.show3 = true;
                    clearInterval(this.timer);
                    this.timer = null;
                    once = true;
                  }
                }, 1000);
              }
            } else {
              this.$message.warning(rst.msg);
            }
          });
      }
    },
    encryption: function (str) {
      let Base64 = require("js-base64").Base64;
      return Base64.encode(str);
    },
    goActiveDetail() {
      this.isShowDetail = true;
    },
    getSiteDetailInfo(id) {
      this.menuActiveName = "站点详细信息";
      this.getSiteDetail(id);
    },
    tabParentMenu(pName, cName) {
      this.menuActiveName = pName;
      this.cildActiveName = cName;
      this.isShowDetail = true;
      if (cName) {
        this.certifySiteName = cName;
      } else {
        this.certifySiteName = pName;
      }
      if (pName == "申请成为站点") {
        this.certifySiteData = this.applyToSite;
        this.pActiveIndex = 1;
      }
      if (pName == "申请标准") {
        this.certifySiteData = this.certifyStandardData;
        this.getSiteCertifyList();
      }
      if (pName == "认证活动") {
        this.getAttestationList();
      }
      if (pName == "站点查询") {
        this.getSitesList();
      }
    },
    tabChildMenu(pName, cId, cName) {
      this.isShowDetail = true;
      this.menuActiveName = pName;
      this.cildActiveName = cName;
      this.certifySiteName = cName;
      if (pName == "申请标准") {
        this.getCertifyNodeList(cId);
      } else if (pName == "认证活动") {
      } else if (pName == "申请成为站点") {
      } else if (pName == "站点查询") {
        this.siteType = cId;
        this.provinceName = "";
        this.getSitesList();
      }
    },
    getMapData() {
      this.mapEchartsData = {
        title: {
          text: "",
          subtext: "",
          x: "center",
          textStyle: {
            color: "#fff"
          }
        },
        tooltip: {
          trigger: "item",
          formatter: function(params) {
            return params.name + " : " + params.value[2];
          }
        },
        visualMap: {
          min: 0,
          max: 200,
          show: false,
          calculable: false,
          inRange: {
            color: ["#65a0f7"]
          },
          textStyle: {
            color: "#fff"
          }
        },
        geo: {
          map: "china",
          layoutCenter: ["50%", "50%"],
          layoutSize: 620,
          label: {
            emphasis: {
              show: false
            }
          },
          itemStyle: {
            normal: {
              areaColor: "#F4F5F7",
              borderColor: "#111"
            },
            emphasis: {
              areaColor: "#ECF0F3"
            }
          },
          regions: [
            {
              name: "南海诸岛",
              value: 0,
              show: false,
              itemStyle: {
                normal: {
                  opacity: 0,
                  label: {
                    show: false
                  },
                  color: "#71D4E7"
                }
              }
            }
          ]
        },
        series: [
          {
            name: "",
            type: "effectScatter",
            scaling: 1.7,
            //该系列使用的坐标系
            coordinateSystem: "geo",
            symbolSize: function(val) {
              return val[2] / 1;
            },
            data: this.mapData,
            //配置何时显示特效'render' 绘制完成后显示特效。'emphasis' 高亮（hover）的时候显示特效。
            showEffectOn: "render",
            //目前只有ripple这一种
            effectType: "ripple",
            //涟漪特效相关配置。
            rippleEffect: {
              //动画的时间
              period: 4,
              //动画中波纹的最大缩放比例
              scale: 4,
              //波纹的绘制方式可选 'stroke' 和 'fill'
              brushType: "stroke"
            },
            //Scatter才有这个属性,是否开启鼠标 hover 的提示动画效果
            hoverAnimation: true
          }
        ]
      };
    },
    toSiteActivityDetail(Id, title) {
      this.isShowDetail = !this.isShowDetail;
      this.activeId = Id;
      this.activeTitle = title;
      // this.$router.push({
      //   name: "siteActivityDetail",
      //   params: {
      //     id: Id
      //   }
      // });
    },
    getProvinceSiteDetail(event, instance, echarts) {
      this.provinceName = event.name;
      this.getSitesList();
    },
    tabShow(num) {
      this.isTab = num;
    },
    goHome() {
      this.$router.push({
        name: "xHome"
      });
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.pageSize = val;
      this.getAttestationList();
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.pageIndex = val;
      this.getAttestationList();
    },
    handleSizeChangeSite(val) {
      this.sitePageSize = val;
      this.getSitesList();
    },
    handleCurrentChangeSite(val) {
      this.sitePageIndex = val;
      this.getSitesList();
    },
    onAllFilesUpload(files) {
      this.fileIds = [];
      this.fileIds = files;
    },
    applyBecomeSite() {
      this.menuActiveName = "申请成为站点";
      this.pActiveIndex = 2;
    },
    verificationMobile() {
      var re = /^1\d{10}$/;
      if (re.test(this.ruleForm.phone)) {
      } else {
        this.$message.warning("手机号格式不正确");
        return false;
      }
    },
    //申请站点
    applySite(isExitPhone) {
      var that = this;
      this.$http
        .post("/api/XOrg/XLogin/applySite", {
          siteName: that.ruleForm.site,
          docIds: this.fileIds,
          associationId: that.association.Id,
          userName: that.ruleForm.manager,
          displayName: that.ruleForm.name,
          moblie: that.ruleForm.phone,
          shortMessage: that.ruleForm.captcha,
          isExitPhone: that.isExitPhone,
          province: that.addProvinceName,
          city: that.addCityName,
          isTrain: that.isTrain,
          isExam: that.isExam

        })
        .then(rst => {
          if (rst.code > 0) {
            that.$message({
              message: rst.msg,
              type: "success"
            });
            that.ruleForm.site = "";
            that.fileIds = [];
            that.files = "";
            that.ruleForm.name="";
            that.ruleForm.manager= "";
            that.ruleForm.phone="";
            that.ruleForm.captcha = "";
            that.isExitPhone = "";
            that.show1= true;
            that.show2= false;
            that.show3= false;
            that.addProvinceName = "";
            that.addCityName = "";
            that.isTrain = "1";
            that.isExam = "1";
          } else if (rst.code == -2) {
            this.$confirm(
              "此手机号码已注册,继续注册,原有账号将不能使用，是否继续?",
              "提示",
              {
                confirmButtonText: "继续",
                cancelButtonText: "取消",
                type: "warning"
              }
            )
              .then(() => {
                that.isExitPhone = true;
                that.applySite(that.isExitPhone);
              })
              .catch(() => {
                this.$message({
                  type: "info",
                  message: "已取消注册"
                });
              });
          } else {
            that.$message({
              message: rst.msg,
              type: "warning"
            });
          }
        });
    },
    //获取申请标准列表
    getSiteCertifyList: function() {
      var that = this;
      this.$http
        .post("/api/XOrg/AssociationSiteList/getAuthenticationList", {
          type: 3
        })
        .then(rst => {
          if (rst.code > 0) {
            that.certifySiteMenu[0].childMenu = rst.list;
            that.getCertifyNodeList(rst.list[0].id);
          }
        });
    },
    //获取申请标准节点介绍
    getCertifyNodeList(id) {
      var that = this;
      this.$http
        .post("/api/XOrg/AssociationSiteList/getCertifyNodeList", {
          authenticationId: id,
          type: 3
        })
        .then(rst => {
          if (rst.code > 0) {
            that.certifySiteData = rst.list;
          }
        });
    },
    //站点查询
    getSitesList() {
      var that = this;
      this.$http
        .post("/api/XOrg/AssociationSiteList/getSitesList", {
          type: that.siteType,
          associationId: that.association.Id,
          provinceName: that.provinceName,
          PageSize: that.sitePageSize,
          page: that.sitePageIndex
        })
        .then(rst => {
          if (rst.code > 0) {
            that.schoolList = rst.siteList;
            that.siteTotalCount = rst.pagination.totalCount;
            that.sitePageSize = rst.pagination.pageSize;
            that.sitePageIndex = rst.pagination.pageIndex;
            that.getSitesMap();
          }
        });
    },
    //站点地图
    getSitesMap() {
      var that = this;
      this.$http
        .post("/api/XOrg/AssociationSiteList/getSitesMap", {
          associationId: that.association.Id,
          type: this.siteType
        })
        .then(rst => {
          if (rst.code > 0) {
            that.mapData = rst.list;
            that.getMapData();
          }
        });
    },
    //站点详情
    getSiteDetail(id) {
      var that = this;
      this.$http
        .post("/api/XOrg/AssociationSiteList/getSiteDetail", {
          id: id
        })
        .then(rst => {
          if (rst.code == 1) {
            that.siteDetailInfo = rst.siteInfo;
          } else {
            that.$message.warning(rst.msg);
          }
        });
    },
    //获取认证活动
    getAttestationList() {
      var that = this;
      this.$http
        .post("/api/XOrg/AttestationActivity/getAttestation", {
          type: 1,
          associationId: that.association.Id,
          siteName: "",
          PageSize: that.pageSize,
          page: that.pageIndex
        })
        .then(rst => {
          if (rst.code == 1) {
            that.siteActivity = rst.list;
            that.total = rst.pagination.totalCount;
            that.pageSize = rst.pagination.pageSize;
            that.pageIndex = rst.pagination.pageIndex;
          } else {
            that.$message.warning(rst.msg);
          }
        });
    }
  }
};
</script>
<style>
</style>
